import { createRouter, createWebHistory } from 'vue-router'
import homeView from '../components/homeView'
import aboutView from '../components/aboutView'
import projectView from '../components/projectView'

const routes = [
      {
        path :'/',
        name :'Homepage',
        component : homeView
      },
      {
        path :'/about',
        name :'About Us',
        component : aboutView
      },
      {
        path :'/project',
        name :'Project',
        component : projectView
      },
      
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
  })

  router.beforeEach((to, from, next) => {
    console.log(to);
    document.title = `${process.env.VUE_APP_TITLE} | ${to.name}`
    next()
  })
  export default router;

